import React from "react";

import { Field } from "formik";
import PropTypes from "prop-types";

import { getInputClassName } from "./Input";
import InputErrorMessage from "./InputErrorMessage";

function InputGroup({
  className = "",
  noForm = false,
  name,
  prefix,
  suffix,
  value,
  ...inputProps
}) {
  const renderInput = (field = null, meta = null) => {
    return (
      <div
        className={`flex flex-row ${getInputClassName(meta, className)} py-0`}
      >
        {prefix && (
          <div className="flex flex-0 flex-row items-center justify-center mr-2">
            {prefix}
          </div>
        )}
        <input
          {...inputProps}
          className={`form-input font-[Roboto] border-0 p-0 outline-none focus:outline-none active:outline-none ring-0 focus:ring-0 active:ring-0 focus:border-0 active:border-0 flex-1 block w-full placeholder:text-gray-400 text-black  ${className}`}
          {...field}
          value={meta?.value ?? value ?? ""}
        />
        {suffix && (
          <div className="flex flex-0 flex-row items-center justify-center ml-2">
            {suffix}
          </div>
        )}
      </div>
    );
  };

  return noForm ? (
    renderInput()
  ) : (
    <>
      <Field name={name}>
        {({ field, meta }) => {
          return renderInput(field, meta);
        }}
      </Field>
      <InputErrorMessage name={name} />
    </>
  );
}

InputGroup.propTypes = {
  className: PropTypes.string,
  noForm: PropTypes.bool,
  name: PropTypes.string,
  prefix: PropTypes.object,
  suffix: PropTypes.object,
  value: PropTypes.any,
};

export default InputGroup;
